import { render, staticRenderFns } from "./DoorMaterials.vue?vue&type=template&id=31d3e9b2"
import script from "./DoorMaterials.vue?vue&type=script&lang=ts"
export * from "./DoorMaterials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports